import React, { useState, useRef } from 'react';
import { updateAvatar } from '../api';
import './UserAvatar.css';

const UserAvatar = ({ user, onAvatarUpdate, onLogout, onStatistikClick, onAccountClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleAvatarClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Prüfe Dateityp
    if (!file.type.startsWith('image/')) {
      alert('Bitte wählen Sie eine Bilddatei aus.');
      return;
    }

    // Prüfe Dateigröße (max 2MB)
    if (file.size > 2 * 1024 * 1024) {
      alert('Die Datei ist zu groß. Maximale Größe: 2MB');
      return;
    }

    setIsUploading(true);
    try {
      // Konvertiere zu Base64
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64Image = e.target.result;
        
        try {
          const response = await updateAvatar({ avatar: base64Image });
          if (response.data.user) {
            // Update localStorage
            const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
            const updatedUser = { ...currentUser, avatar: response.data.user.avatar };
            localStorage.setItem('user', JSON.stringify(updatedUser));
            
            // Callback für Parent-Komponente
            if (onAvatarUpdate) {
              onAvatarUpdate(updatedUser);
            }
          }
        } catch (error) {
          console.error('Avatar upload failed:', error);
          alert('Fehler beim Hochladen des Avatars.');
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('File reading failed:', error);
      alert('Fehler beim Lesen der Datei.');
    } finally {
      setIsUploading(false);
      setIsMenuOpen(false);
    }
  };



  const getInitials = (username) => {
    return username ? username.charAt(0).toUpperCase() : '?';
  };

  return (
    <div className="user-avatar-container">
      <div 
        className={`user-avatar ${isUploading ? 'uploading' : ''}`}
        onClick={handleAvatarClick}
      >
        {user?.avatar ? (
          <img 
            src={user.avatar} 
            alt="User Avatar" 
            className="avatar-image"
          />
        ) : (
          <div className="avatar-initials">
            {getInitials(user?.username)}
          </div>
        )}
        {isUploading && <div className="upload-spinner" />}
      </div>

      {isMenuOpen && (
        <div className="avatar-menu">
          <button 
            className="avatar-menu-item"
            onClick={onAccountClick}
          >
            👤 Account
          </button>
          <div className="avatar-menu-divider"></div>
          <button 
            className="avatar-menu-item statistik-item"
            onClick={onStatistikClick}
          >
            📊 Statistik
          </button>
          <button 
            className="avatar-menu-item logout-item"
            onClick={onLogout}
          >
            🚪 Abmelden
          </button>
        </div>
      )}

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default UserAvatar;
